import styled from 'styled-components';
import { em } from 'styles';

import { Input } from 'components/_shared/Input';
import { themeDefault } from '../../styles/themes/theme.default';

const breakpoint = '768px';

export const Container = styled.div`
  display: flex;
  gap: ${em(14)};
  @media (max-width: ${breakpoint}) {
    display: block;
  }
  justify-content: space-between;
`;

export const Filters = styled.div`
  padding: ${em(10)};
  background: #fff;
  border-radius: 5px;
  width: ${em(320)};
  @media (max-width: ${breakpoint}) {
    width: 100%;
  }
`;

export const DateInput = styled(Input)`
  margin: ${em(6)} 0;
  & input {
    font-size: ${em(14)};
  }
`;
export const HelpText = styled.p`
  text-align: center;
  margin: 10px auto;
  font-size: ${em(18)};
`;

export const AccentText = styled(HelpText)`
  font-size: ${em(24)};
  color: ${themeDefault.colors.primary.p1};
`;

export const SelectOption = styled.span`
  font-size: ${em(14)};
`;

export const InfoContainer = styled(Container)`
  border: groove ${themeDefault.colors.primary.p2} ${em(1)};
  padding: ${em(16)};
  border-radius: ${em(16)};
  min-width: -webkit-fill-available;
  background: #fff;
  display: flex;
  flex-direction: column;
  align-content: center;
  flex-wrap: wrap;
`;

export const Info = styled.div``;
